// ** Third Party Components
import styled from "styled-components";

// ** Styles Import
import { breakpoints } from "styles/grid";

// ** Custom Components
import { ButtonLanding } from "components/layout/Button/ButtonLanding";

// #####################################################

export const StyledLoginHeaderButton = styled((props) => (
	<ButtonLanding {...props} />
))`
	width: 350px;
	height: 35px;
	font-size: 1rem;

	// Na max-width jest -1 pixel, żeby nie robiły się bugi na breakpointach np. 600/1050px, więcej w tasku DZ-2263.
	@media (max-width: ${breakpoints.desktop - 1}px) {
		max-width: 185px;
	}
	@media (max-width: ${breakpoints.phone - 1}px) {
		width: auto;
	}
`;

// #####################################################
